ANALYTICS_ENABLED = document.querySelector("meta[name=analytics_enabled]")?.content is "true"

# Wrapper for Segment.io analytics functions
#
# Analytics may be disabled in some environments. These functions should all be
# no-op if analytics is disabled (i.e. no window.analytics object is defined)
@Analytics = (->

  # We want to delay all analytics calls until we have sent the alias
  # instruction to mixpanel. This prevents us creating a full user where
  # we instead want an alias
  aliased = false

  # Reports user info to Segment. Should be called once per page load.
  # Takes a user object:
  #   {
  #     id: "12ab45",
  #     name: "Emily N",
  #     email: "emily@com.com"
  #     account: "acme-co"
  #   }
  trackAccount = (user) ->
    return unless analyticsEnabled()

    # Track the current account
    window.analytics.ready ->
      # This can only get called after mixpanel has loaded as isAnonymous
      # calls through
      window.analytics.alias(user.account_slug) if mixpanel.get_distinct_id() != user.account_slug
      window.analytics.identify(user.account_slug, {
        name: user.account_name,
        email: user.senior_user_email,
        createdAt: user.account_created_at,
        plan: user.account_plan
      })
      aliased = true

  # Reports an event to Segment
  # Takes an event name and optional properties object:
  # - "Signed Up"
  # - { something: true }
  trackEvent = (eventName, properties) ->
    return unless analyticsEnabled()
    if aliased
      window.analytics.track(eventName, properties)
    else
      setTimeout((-> trackEvent(eventName, properties)), 100)

  trackPage = ->
    return unless analyticsEnabled()
    window.analytics.page()

  analyticsEnabled = ->
    window.analytics && ANALYTICS_ENABLED

  # Expose public functions:
  return {
    trackAccount: trackAccount
    trackEvent: trackEvent
    trackPage: trackPage
  }
)()

Analytics.trackPage()

# Report user info on page load
user = document.querySelector("#analytics_user")
user = JSON.parse(user.content) if user
Analytics.trackAccount(user) if user

events = document.querySelector("#analytics_events")
events = JSON.parse(events.content) if events
events.forEach((event) -> Analytics.trackEvent(event)) if events
